import * as events from '../base/constant';
import { Uploader } from '@syncfusion/ej2-inputs';
import { EXPORT_STYLES } from '../../common/export-styles';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * ImportExport module called when import and export content in RichTextEditor
 */
export class ImportExport {
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    addEventListener() {
        this.parent.on(events.onImport, this.onImport, this);
        this.parent.on(events.onExport, this.onExport, this);
        this.parent.on(events.destroy, this.destroy, this);
    }
    onImport() {
        const actionBegin = {
            cancel: false,
            requestType: 'Import'
        };
        this.parent.trigger(events.actionBegin, actionBegin, (actionBeginArgs) => {
            if (!actionBeginArgs.cancel) {
                if (isNullOrUndefined(this.uploaderObj)) {
                    this.uploaderObj = new Uploader({
                        allowedExtensions: '.doc,.docx,.rtf,.dot,.dotx,.docm,.dotm',
                        asyncSettings: {
                            saveUrl: this.parent.importWord.serviceUrl
                        },
                        uploading: (e) => {
                            if (!this.parent.isServerRendered) {
                                this.parent.trigger(events.wordImporting, e);
                            }
                        },
                        success: (args) => {
                            this.parent.executeCommand('importWord', args.e.currentTarget.response, { undo: true });
                            this.parent.trigger(events.actionComplete, { requestType: 'Import' });
                        }
                    });
                }
                this.parent.setProperties({ enableXhtml: true }, true);
                const uploadParentEle = this.parent.createElement('div', { className: 'e-import-uploadwrap e-droparea' + this.parent.getCssClass(true) });
                const uploadEle = this.parent.createElement('input', {
                    id: this.rteID + '_upload', attrs: { type: 'File', name: 'UploadFiles' }, className: this.parent.getCssClass()
                });
                uploadParentEle.appendChild(uploadEle);
                this.uploaderObj.appendTo(uploadEle);
                this.uploaderObj.element.click();
                this.uploaderObj.element.closest('.e-upload').style.display = 'none';
            }
        });
    }
    onExport(args) {
        let filename;
        let serviceUrl;
        this.parent.setProperties({ enableXhtml: true }, true);
        const rteHtmlData = this.parent.getHtml();
        let html;
        if (args.member === 'ExportWord') {
            filename = this.parent.exportWord.fileName;
            serviceUrl = this.parent.exportWord.serviceUrl;
            html = `<html><head><style>${this.parent.exportWord.stylesheet + EXPORT_STYLES}</style></head><body><div class="e-content">${rteHtmlData}</div></body></html>`;
        }
        else if (args.member === 'ExportPdf') {
            filename = this.parent.exportPdf.fileName;
            serviceUrl = this.parent.exportPdf.serviceUrl;
            html = `<html><head><style>${this.parent.exportPdf.stylesheet + EXPORT_STYLES}</style></head><body><div class="e-content">${rteHtmlData}</div></body></html>`;
        }
        const actionBegin = {
            requestType: args.member,
            exportValue: html,
            cancel: false
        };
        this.parent.trigger(events.actionBegin, actionBegin, (actionBeginArgs) => {
            if (!actionBeginArgs.cancel) {
                const exportArgs = {
                    exportType: (args.member === 'ExportPdf' ? 'PDF' : 'Word')
                };
                this.parent.trigger(events.documentExporting, exportArgs);
                const headers = {
                    'Content-Type': 'application/json'
                };
                if (exportArgs.currentRequest) {
                    for (const h of exportArgs.currentRequest) {
                        Object.assign(headers, h);
                    }
                }
                const payload = exportArgs.customFormData
                    ? { html: actionBeginArgs.exportValue, formData: exportArgs.customFormData }
                    : { html: actionBeginArgs.exportValue };
                fetch(serviceUrl, {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(payload)
                })
                    .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    return response.blob().then((blob) => ({ blob, filename }));
                })
                    .then(({ blob, filename }) => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                    this.parent.trigger(events.actionComplete, { requestType: args.member });
                })
                    .catch((error) => {
                    console.error('Fetch error:', error);
                });
            }
        });
    }
    destroy() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.off(events.onImport, this.onImport);
        this.parent.off(events.onExport, this.onExport);
        this.parent.off(events.destroy, this.destroy);
        if (this.uploaderObj && !this.uploaderObj.isDestroyed) {
            this.uploaderObj.destroy();
            this.uploaderObj = null;
        }
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     * @hidden
     */
    getModuleName() {
        return 'importExport';
    }
}
